// Get current url path
const url = new URL(window.location.href);
const path = url.pathname;
console.log("PATH");
console.log(path);

// If on my-account page
if (path === "/my-account/") {
  document.body.classList.add("my-account-dashboard");
}
